"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.download = exports.downloadPCM = exports.downloadWAV = void 0;
/**
 * 下载录音文件
 * @private
 * @param {*} blob      blob数据
 * @param {string} name 下载的文件名
 * @param {string} type 下载的文件后缀
 */
function _download(blob, name, type) {
    var oA = document.createElement('a');
    oA.href = window.URL.createObjectURL(blob);
    oA.download = name + "." + type;
    oA.click();
}
/**
 * 下载录音的wav数据
 *
 * @param {blob}   需要下载的blob数据类型
 * @param {string} [name='recorder']    重命名的名字
 */
function downloadWAV(wavblob, name) {
    if (name === void 0) { name = 'recorder'; }
    _download(wavblob, name, 'wav');
}
exports.downloadWAV = downloadWAV;
/**
 * 下载录音pcm数据
 *
 * @param {blob}   需要下载的blob数据类型
 * @param {string} [name='recorder']    重命名的名字
 * @memberof Recorder
 */
function downloadPCM(pcmBlob, name) {
    if (name === void 0) { name = 'recorder'; }
    _download(pcmBlob, name, 'pcm');
}
exports.downloadPCM = downloadPCM;
// 通用下载接口
function download(blob, name, type) {
    return _download(blob, name, type);
}
exports.download = download;
//# sourceMappingURL=download.js.map